module.exports = __webpack_public_path__ + "static/media/jardin.c21630c3.jpg";